export default __webpack_public_path__ + "static/media/radio-usage.44897238.svg";